import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useContextTypes } from 'ui-components/hooks/use-context-types';

import { customsPropTypesObject } from '../../../../prop-types/customs';
import { CustomsService } from '../../../../services/customs-service';
import { useDdpCountryConfig } from '../../../../hooks/use-ddp-country-config';
import { useDdpEligibleCarriers } from '../../../../hooks/use-ddp-eligible-carriers';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';

import ErrorBadgeWithTooltip from '../../../error-badge-with-tooltip';
import { CustomsContext } from '../../context/context';

import messages from '../messages';

export const CustomsErrorBadge = () => {
  const intl = useIntl();
  const { isDdpAvailable: enablePrepaidDutiesAndTax } = useDdpCountryConfig();
  const { isDdpEligibleBySellerLabelProviderId } = useDdpEligibleCarriers();
  const { serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();

  const shouldShowHsCodeFetchingAndValidation =
    enablePrepaidDutiesAndTax && isDdpEligibleBySellerLabelProviderId(serviceIdAndSellerLabelProviderId?.sellerLabelProviderId as string);

  useContextTypes('CustomsErrorBadge', CustomsContext, customsPropTypesObject);
  const customs = useContext(CustomsContext);
  const customsHasErrors = CustomsService.customsHasErrors(customs, shouldShowHsCodeFetchingAndValidation);

  if (!customsHasErrors) {
    return null;
  }

  const errors = [intl.formatMessage(messages.headerErrorIndicator)];

  return <ErrorBadgeWithTooltip errors={errors} layout='text-with-background' position='bottom-right' />;
};
